
import { MapLocation } from '@/types/location';

// Karate House Gym Locations
export const karateHouseGyms: MapLocation[] = [
  {
    id: 11001,
    name: "Karate House - Riyadh (Al Muroj)",
    type: "Gym",
    devices: 4,
    coordinates: [24.756575626693447, 46.65568827407806],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "18-45",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
